import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IPaymentSettings } from 'src/app/store/payment-settings/payment-settings.actions';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentSettingsService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get('https://api-fake-r9p5.onrender.com/paymentSettings') as Observable<
      IPaymentSettings[]
    >;
    // .pipe(map((res: any) => res['hydra:member']))
  }

  get(id: any) {
    return this.http.get(
      `${environment.url}/clients/${id}`
    ).pipe(map((res: any) => res['paymentSetting'])) as Observable<IPaymentSettings>;
    // .pipe(map((res: any) => res['hydra:member']))
  }

  save(req: IPaymentSettings) {
    return this.http.post(
      'https://api-fake-r9p5.onrender.com/paymentSettings',
      req
    ) as Observable<IPaymentSettings>;
  }

  edit(req: IPaymentSettings, id: number) {
    const data = {
      paymentSetting: req
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(`${environment.url}/clients/${id}`, data, {
      headers: headers,
    }) as Observable<IPaymentSettings>;
  }

  delete(id: number) {
    return this.http.delete(
      `https://api-fake-r9p5.onrender.com/paymentSettings/${id}`
    ) as Observable<IPaymentSettings>;
  }
}
